import { type DynamicLinkState } from '~/features/DynamicLinks/types/dynamic-links-states.enum'
import { StoplightColor } from '~/features/shared/types/surveys/stoplight.color'
import { COLORS } from '~/theme'

type ChipColor =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning'

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class ColorUtils {
  public static stoplightValueToColor(value: StoplightColor) {
    const COLORS_MAP = {
      [StoplightColor.RED]: COLORS.RED,
      [StoplightColor.GREEN]: COLORS.GREEN,
      [StoplightColor.YELLOW]: COLORS.YELLOW,
      [StoplightColor.SKIPPED]: COLORS.SKIPPED_GREY,
      [StoplightColor.DOES_NOT_APPLY]: COLORS.DOES_NOT_APPLY_GREY,
    } as const

    return COLORS_MAP[value]
  }

  public static dynamicLinkStatusToChipColor(
    status?: DynamicLinkState,
  ): ChipColor {
    const STATUS_COLOR_MAP: Record<string, ChipColor> = {
      ACTIVE: 'success',
      INACTIVE: 'default',
      EXPIRED: 'error',
    }

    return status ? STATUS_COLOR_MAP[status] ?? 'default' : 'default'
  }
}
